import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Input } from "./ui/input";

export default function EmailCode({ email, code, setCode, error }) {
  const [busy, setBusy] = useState(false);
  const [sentTo, setSentTo] = useState("");
  if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email || "")) return null;
  const send = async () => {
    setBusy(true);
    try { await api.post("/auth/email-code", { email }); setSentTo(email); toast.success(`Code sent to ${email}`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.03] p-3 space-y-2" data-testid="email-code-box">
      <p className="text-xs text-slate-400 flex items-center gap-1.5"><MailCheck size={14} className="text-[#00f0ff]" />Verify your email with a 6-digit code</p>
      <div className="flex gap-2">
        <Input data-testid="email-code-input" inputMode="numeric" maxLength={6} placeholder="6-digit code" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} className="h-11 flex-1 min-w-0" />
        <button type="button" data-testid="email-code-send" disabled={busy} onClick={send} className="px-4 h-11 rounded-full bg-white text-black text-sm font-semibold shrink-0 disabled:opacity-40">
          {busy ? <Loader2 size={14} className="animate-spin" /> : sentTo === email ? "Resend" : "Send code"}
        </button>
      </div>
      {error && <p className="text-xs text-red-400" data-testid="email-code-error">{error}</p>}
    </div>
  );
}
